import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const timeout = 300


const Transition = ({ children, location }) => {
  const mainRef = useRef();

  // Animate on mount and pathname change
  useEffect(() => {
    const el = mainRef.current;

    gsap.fromTo(
      el,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.3, ease: "power2.out" }
    );

    return () => {
      gsap.to(el, {
        opacity: 0,
        y: -30,
        duration: 0.3,
        ease: "power2.in",
      });
    };
  }, [location.pathname]);

  return (
    <main ref={mainRef} key={location.pathname}>
      {children}
    </main>
  );
};
// class Transition extends React.PureComponent {
//     render() {
//         const { children, location } = this.props

//         return (
//             <TransitionGroup>
//                 <ReactTransition
//                     key={location.pathname}
//                     timeout={{
//                         enter: timeout,
//                         exit: timeout,
//                     }}
//                 >
//                     {status => (
//                         <div
//                             style={{
//                                 ...getTransitionStyles[status],
//                             }}
//                         >
//                             {children}
//                         </div>
//                     )}
//                 </ReactTransition>
//             </TransitionGroup>
//         )
//     }
// }

export default Transition
